import { render, staticRenderFns } from "./instructClassify.vue?vue&type=template&id=5cccc82e&"
import script from "./instructClassify.vue?vue&type=script&lang=js&"
export * from "./instructClassify.vue?vue&type=script&lang=js&"
import style0 from "./instructClassify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cccc82e')) {
      api.createRecord('5cccc82e', component.options)
    } else {
      api.reload('5cccc82e', component.options)
    }
    module.hot.accept("./instructClassify.vue?vue&type=template&id=5cccc82e&", function () {
      api.rerender('5cccc82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/instruct/instructClassify.vue"
export default component.exports